import CONST from "../../config/CONST";
import {logInfo} from "../../helpers/debugLog";
import React from "react";
import InstallmentPreviewWidgetPortal from "../InstallmentPreviewWidgetPortal/InstallmentPreviewWidgetPortal";
import {getEIMFromMSC} from "../../helpers/financialProductConfigurationHelpers";

const HandleInstallmentPreviewWidgetPortals = () => {

    const portalContainers = document.querySelectorAll(CONST.PREVIEW_WIDGET_SELECTOR);

    logInfo('HandleInstallmentPreviewWidgetPortals', portalContainers);


    if(portalContainers && portalContainers.length) {
        return (
            <>
                { [...portalContainers].map( (el, i) => {   // [...portalContainers] is required to convert a NodeList Object into an Array

                    logInfo('Render InstallmentPreviewWidget in element', el);

                    // logInfo('===','data attributes (getAttribute)', el.getAttribute('data-fincalc'));
                    // logInfo('===','data attributes (getAttribute json parsed)', JSON.parse(el.getAttribute('data-fincalc')));
                    // logInfo('===','data attributes (dataset)', el.dataset.fincalc);
                    // logInfo('===','data attributes (dataset)', JSON.parse(el.dataset.fincalc));

                    el.innerHTML = '';
                    return(
                        <InstallmentPreviewWidgetPortal
                            key={`preview-widget-${i}`}
                            el={el}
                            data={{
                                ...JSON.parse(el.getAttribute('data-fincalc')),
                                EIM: getEIMFromMSC(JSON.parse(el.getAttribute('data-fincalc')).EIM)
                            }}
                        />
                    )
                }) }
            </>
        );
    }

    return null;

}

export default HandleInstallmentPreviewWidgetPortals;